import { EventData } from 'lib/EventLogger/Event';
import { createContext } from 'react';

const TrackingDataContext = createContext<Partial<EventData>>({});

export default TrackingDataContext;
